import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'

export const LayoutPanel = ({ children, loading, style, props }) => {
  return (
    <Element
      className="positionRelative h100"
      style={{
        backgroundColor: '#FFFFFF',
        borderRadius: 8,
        padding: '12px 8px',
      }}
    >
      {loading ? (
        <>
          <Loading />
        </>
      ) : (
        <div
          className="h100"
          style={{
            opacity: loading ? 0 : 1,
            pointerEvents: loading ? 'none' : 'auto',
            ...style,
          }}
          {...props}
        >
          {children}
        </div>
      )}
    </Element>
  )
}
